import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/app/(signup)/error.tsx");
